import { Box, LinearProgress, Stack, Typography } from "@mui/material";
import Image from "src/components/Image";
import useLocales from "src/hooks/useLocales";
import useResponsive from "src/hooks/useResponsive";

// ----------------------------------------------------------------------

export default function ImportingMessage() {
	const isMobile = useResponsive("down", "sm");
	const { translate } = useLocales();

	return (
		<Stack sx={{ alignItems: "center" }}>
			<Image src='/ilustrations/extraction_amico.svg' sx={{ width: { xs: 200, sm: 300 } }} />
			<Stack sx={{ width: { xs: 250, sm: 400 }, py: 4 }}>
				<LinearProgress sx={{ height: 3 }} />
			</Stack>
			<Box sx={{ maxWidth: 700, margin: "auto", textAlign: "center", mt: { xs: 1, sm: 1 } }}>
				<Typography paragraph variant={isMobile ? "h4" : "h3"}>
					{translate("importing.title")}
				</Typography>
				<Typography sx={{ color: "text.secondary" }} variant={isMobile ? "body2" : "body1"}>
					{translate("importing.description")}
				</Typography>
			</Box>
		</Stack>
	);
}
